import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async cancelarCompra(api, parametros) {
    parametros.operacao = 'cancelarCompra';

    let retorno = {};

    await api.santriPOST('/rest/compra', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCompra/RCompraCancelarCompra.js